import React, { useRef } from 'react';
import { MenuCard } from './MenuCard';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { FriesIcon } from './SectionIcons';
export function Extras() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="w-full bg-bp-bg py-20 px-6 md:px-20" data-id="element-26" data-mp="17nl977ap7edn">
      <div className="max-w-container mx-auto" data-id="element-27" data-mp="tp51bd13nhtx">
        <motion.div ref={ref} className="flex flex-col items-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6
      }} data-id="element-28" data-mp="tnaetua6jhnq">
          <FriesIcon className="mb-4" data-id="element-29" data-mp="2j2s298orib9p" />
          <h2 className="font-display text-[32px] md:text-[48px] leading-none text-bp-text tracking-[0.1em] uppercase text-center" data-id="element-30" data-mp="2j1p90u3yvwqm">
            EXTRAS
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 max-w-4xl mx-auto" data-id="element-31" data-mp="vambxnnryova">
          <MenuCard name="COMBO" price="+6.000" ingredients={['Papas fritas artesanales.', 'Cualquier bebida del menú.']} delay={0} data-id="element-32" data-mp="19yh7rcx2x9cl" />

          <MenuCard name="PAPAS FRITAS ARTESANALES" price="4.000" ingredients={['120 g']} delay={0.1} data-id="element-33" data-mp="hcy178nf8y3y" />
        </div>
      </div>
    </section>;
}